import React, { useState, useEffect } from 'react';
import { Form, Input, Divider, InputNumber, Row, Col, Typography, Select, Button, Space } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { Option } = Select;

const LogicNodeProperties = ({ config, nodeType, inputSchema, updateConfig }) => {
  const [ranges, setRanges] = useState(config.ranges || []);

  // Sync ranges to form/config when they change
  useEffect(() => {
    if (updateConfig) {
      updateConfig({ ranges });
    }
  }, [ranges]);

  const addRange = () => {
    const newRange = {
      id: `range_${Date.now()}`,
      min: null,
      max: null,
      output: `output_${ranges.length + 1}`
    };
    setRanges([...ranges, newRange]);
  };

  const updateRange = (index, updates) => {
    const newRanges = [...ranges];
    newRanges[index] = { ...newRanges[index], ...updates };
    setRanges(newRanges);
  };

  const removeRange = (index) => {
    setRanges(ranges.filter((_, i) => i !== index));
  };

  if (nodeType === 'range_branch') {
    return (
      <>
        <Form.Item label="Field" name="field" initialValue={config.field} rules={[{ required: true }]}>
          {inputSchema && inputSchema.length > 0 ? (
            <Select placeholder="Numeric column name" showSearch>
              {inputSchema.map(col => (
                <Option key={col.name} value={col.name}>{col.name}</Option>
              ))}
            </Select>
          ) : (
            <Input placeholder="Numeric column name" />
          )}
        </Form.Item>

        <Divider orientation="left" orientationMargin="0">Ranges</Divider>
        
        <Row gutter={8} style={{ marginBottom: 8 }}>
          <Col span={6}><Text strong style={{ fontSize: '12px' }}>Min</Text></Col>
          <Col span={6}><Text strong style={{ fontSize: '12px' }}>Max</Text></Col>
          <Col span={9}><Text strong style={{ fontSize: '12px' }}>Output</Text></Col>
          <Col span={3}></Col>
        </Row>

        {ranges.map((range, index) => (
          <Row gutter={8} key={range.id || index} style={{ marginBottom: 8 }}>
            <Col span={6}>
              <InputNumber 
                size="small"
                value={range.min} 
                onChange={(val) => updateRange(index, { min: val })}
                style={{ width: '100%' }}
                placeholder="Min" 
              />
            </Col>
            <Col span={6}>
              <InputNumber 
                size="small"
                value={range.max} 
                onChange={(val) => updateRange(index, { max: val })}
                style={{ width: '100%' }}
                placeholder="Max" 
              />
            </Col>
            <Col span={9}>
              <Input 
                size="small"
                value={range.output} 
                onChange={(e) => updateRange(index, { output: e.target.value })}
                placeholder="Output port" 
              />
            </Col>
            <Col span={3}>
              <Button 
                size="small" 
                type="text" 
                danger 
                icon={<DeleteOutlined />}
                onClick={() => removeRange(index)}
              />
            </Col>
          </Row>
        ))}

        <Button 
          type="dashed" 
          onClick={addRange}
          block
          icon={<PlusOutlined />}
          style={{ marginTop: 8, marginBottom: 16 }}
          size="small"
        >
          Add Range
        </Button>

        <div style={{ padding: '8px 12px', backgroundColor: '#f9f9f9', borderRadius: '4px', fontSize: '12px' }}>
          <Text type="secondary">
            <strong>Range Branch:</strong><br/>
            • Routes data to different outputs based on numeric value<br/>
            • Leave Min empty for -∞, Max empty for +∞<br/>
            • Rows not matching any range go to "default" output
          </Text>
        </div>
      </>
    );
  }

  return null;
};

export default LogicNodeProperties;